import gql from 'graphql-tag'
import {useQuery} from '@apollo/client'
import {useGetFiltersData} from './getFiltersData'

const personaOutreachQuery = gql`
  query personaOverview($filters: Filters, $persona: String!, $benefits: [BenefitEligibility]) {
    personaOverview(filters: $filters, persona: $persona, benefits: $benefits) {
      outreach
    }
  }
`

export default function PersonaOutreach() {
  const {filtersData, personaSidebarOpen, benefitsData} = useGetFiltersData()

  const {
    data: personaOutreach,
    loading: loadingPersonaOutreach,
    refetch: refetchPersonaOutreach,
    error: errorLoadingPersonaOutreach
  } = useQuery(personaOutreachQuery, {
    variables: {
      filters: filtersData,
      persona: personaSidebarOpen?.name,
      benefits: benefitsData[0]
    },
    notifyOnNetworkStatusChange: true,
    errorPolicy: 'all'
  })
  return {personaOutreach, loadingPersonaOutreach, refetchPersonaOutreach, errorLoadingPersonaOutreach}
}
